/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 道路種別
 */
export type IncidentRoadTypeEnum =
  (typeof IncidentRoadTypeEnum)[keyof typeof IncidentRoadTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IncidentRoadTypeEnum = {
  TOHOKU_EXPRESSWAY: 'TOHOKU_EXPRESSWAY',
  SENDAI_EAST_ROAD: 'SENDAI_EAST_ROAD',
  SANRIKU_EXPRESSWAY: 'SANRIKU_EXPRESSWAY',
  SENDAI_SOUTH_ROAD: 'SENDAI_SOUTH_ROAD',
  SENDAI_NORTH_ROAD: 'SENDAI_NORTH_ROAD',
  YAMAGATA_EXPRESSWAY: 'YAMAGATA_EXPRESSWAY',
} as const;
